"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * スクロールアニメーション
 */
const observerOptions = {
    root: null,
    rootMargin: "0px 0px",
    threshold: 0.5,
};
const observerSet = (callback, observerTargets) => {
    const observer = new IntersectionObserver(callback, observerOptions);
    observerTargets.forEach((observerTarget) => {
        observer.observe(observerTarget);
    });
};
/**
 * クラス属性の追加
 */
const effect = (effectTargets) => {
    observerSet(callback, effectTargets);
    function callback(entries) {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > observerOptions.threshold &&
                !entry.target.classList.contains("is-visible")) {
                if (entry.isIntersecting) {
                    entry.target.classList.add("is-visible");
                }
            }
        });
    }
};
/**
 * 一文字ずつ<span>で囲む
 */
const charWrapSpan = (str) => {
    return [...str]
        .map((char) => `<span aria-hidden='true' class='js-char'>${char}</span>`)
        .join("");
};
/**
 * テキストを1文字ずつ表示
 */
const typing = (typeTargets) => {
    observerSet(callback, typeTargets);
    function callback(entries) {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > observerOptions.threshold &&
                !entry.target.classList.contains("is-visible")) {
                if (entry.isIntersecting) {
                    entry.target.classList.add("is-visible");
                    typeTargets.forEach((typeTarget) => {
                        typeTarget.innerHTML = charWrapSpan(typeTarget.textContent);
                        [...typeTarget.children].forEach((char, index) => {
                            const delay = 100;
                            setTimeout(() => {
                                char.style.transitionDelay = `${delay * index}ms`;
                                char.classList.add("is-animated");
                            }, delay);
                        });
                    });
                }
            }
        });
    }
};
const scrollAnimationInit = () => {
    const effectTargets = document.querySelectorAll("[data-effect]:not([data-effect='typing'])");
    const typeTargets = document.querySelectorAll("[data-effect='typing']");
    effect(effectTargets);
    typing(typeTargets);
};
exports.default = scrollAnimationInit;
